// Third-party Imports
import { configureStore } from '@reduxjs/toolkit'

import categoryReducer from './slices/categorySlice'
import bannerReducer from './slices/bannerSlice'
import subCategoryReducer from './slices/subCategory'
import settingsReducer from './slices/settingsSlice'
import productReducer from './slices/productSlice'
import brandReducer from './slices/brandSlice'
import attributeReducer from './slices/attributeSlice'
import campaignReducer from './slices/campaignSlice'
import emailCampaignReducer from './slices/emailCampaignSlice'
import offerReducer from './slices/offerSlice'

// Simple placeholder reducer to prevent empty reducer error
const appReducer = (state = {}) => state

export const store = configureStore({
  reducer: {
    app: appReducer,
    categories: categoryReducer,
    banners: bannerReducer,
    subCategories: subCategoryReducer,
    settings: settingsReducer,
    products: productReducer,
    brands: brandReducer,
    attributes: attributeReducer,
    campaigns: campaignReducer,
    emailCampaigns: emailCampaignReducer,
    offers: offerReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
